import { useCallback, useEffect, useState } from 'react'
import { getUserSessions } from '../../../API/UserSessions/UserSessions';
import { UserSession } from '../../../API/UserSessions/models';
import { useLocation } from 'react-router-dom';
import { UserSelector } from './UserSelector';
import { SessionsList } from './components/SessionsList';
import { Button } from 'react-bootstrap';
import { FaSync } from 'react-icons/fa';
import { Title } from '../../../../Templates/Title';
import { IoCalendar } from 'react-icons/io5';
import { DateSelector } from './DateSelector';
import { toast } from 'react-hot-toast';

interface Filters {
    startDate: string;
    endDate: string;
    userId: string;
}

export const UserSessions = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const userId = params.get('user');

    const today = new Date();
    const twoMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 2, today.getDate());
    const twoMonthsAgoString = twoMonthsAgo.toISOString().split('T')[0];
    const todayString = today.toISOString().split('T')[0];

    const [isLoading, setIsLoading] = useState(true);
    const [userSessions, setUserSessions] = useState<UserSession[]>([]);
    // const [selectedUser, setSelectedUser] = useState<any | null>(null);

    const [filters, setFilters] = useState<Filters>({ startDate: twoMonthsAgoString, endDate: todayString, userId: '' });

    const validateFilters = useCallback(() => {
        if (filters.startDate && filters.endDate) {
            const start = new Date(filters.startDate);
            const end = new Date(filters.endDate);
            const diffMonths = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
            if (diffMonths > 2) {
                toast.error('El rango de fechas no puede ser mayor a 2 meses');
                return false;
            }
        }
        return true;
    }, [filters.endDate, filters.startDate]);

    const fetchUserSessions = useCallback(async () => {
        setIsLoading(true);

        if (!validateFilters()) return;

        if (filters.userId) {
            const data = await getUserSessions({ userId: filters.userId, startDate: filters.startDate, endDate: filters.endDate });
            if (data.userSessions) {
                setUserSessions(data.userSessions);
            }
        }
        setIsLoading(false);

    }, [filters.endDate, filters.startDate, filters.userId, validateFilters]);

    const cleanFilters = () => {
        setFilters({ ...filters, startDate: twoMonthsAgoString, endDate: todayString });
    }

    const handleSearch = () => {
        if (!validateFilters()) return;
        fetchUserSessions();
    }

    useEffect(() => {
        if (userId) {
            setFilters({ ...filters, userId: userId });
        }
    }, [filters, userId, fetchUserSessions]);

    useEffect(() => {
        fetchUserSessions();
    }, [filters, fetchUserSessions]);

    return (
        <div className="mt-4 pb-5">

            <div className='d-flex justify-content-between align-items-center mb-4'>
                <Title
                    title='Sesiones de usuario'
                    icon={<IoCalendar size={24} />}
                    subtitle='Muestra las sesiones de usuario'
                />
                <Button
                    variant="primary"
                    onClick={() => fetchUserSessions()}
                    className="d-flex align-items-center gap-2"
                >
                    <FaSync size={16} />
                    Actualizar
                </Button>
            </div>
            <div className="mb-2 d-flex gap-2 w-100 justify-content-between">
                <div style={{ width: '300px' }}>
                    <UserSelector setFilters={setFilters} filters={filters} />
                </div>
                <div className='d-flex gap-2'>
                    <DateSelector filters={filters} setFilters={setFilters} />
                    <div className='d-flex align-items-center gap-2 mt-3'>
                        <Button variant="secondary" onClick={handleSearch}>
                            Buscar
                        </Button>
                        <Button variant="secondary" onClick={() => cleanFilters()}>
                            Limpiar
                        </Button>
                    </div>
                </div>
            </div>

            {isLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <span className="text-white">Cargando sesiones...</span>
                </div>
            ) : (
                <>
                    {filters.userId ? (
                        <SessionsList sessions={userSessions} />
                    ) : (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                            <span className="text-white">Selecciona un usuario para ver sus sesiones</span>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
